import { render, staticRenderFns } from "./QEditStaff.vue?vue&type=template&id=6b6977a5&"
import script from "./QEditStaff.vue?vue&type=script&lang=js&"
export * from "./QEditStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports